import teamCover from "/images/createTeamCover.png";
import fallbackImgSrc from "/images/fallback.png";

export const Images = {
  FallbackImg: fallbackImgSrc,
  TeamCover: teamCover,
};
